/* =========================================================================
   Phishiness / [DL] — Material Tailwind theme override.
   Passed to the app-root <ThemeProvider value={phishTheme}> in main.tsx so MT
   components inherit the terminal aesthetic: brand color, sharp/4px/8px radii,
   no drop shadow, no ripple, no uppercase.

   We lean on `className` passthrough for the precise look (MT v2 can reject
   custom color KEYS like "phish-accent" in its color enum); these defaults
   just set sane on-brand starting points so un-classed instances aren't off.
   Anything MT can't express (Terminal block, ScoreTile ring, data table) is
   custom — see src/components/ui.
   ========================================================================= */

export const phishTheme = {
  button: {
    defaultProps: { ripple: false, variant: 'filled' as const },
    styles: {
      base: {
        initial: {
          fontFamily: 'font-mono',
          fontWeight: 'font-medium',
          textTransform: 'normal-case',
          borderRadius: 'rounded-phish',
          boxShadow: 'shadow-none hover:shadow-none',
          letterSpacing: 'tracking-phish-mono',
          transitionDuration: 'duration-phish',
        },
      },
    },
  },

  input: {
    defaultProps: { variant: 'outlined' as const, color: 'green' as const },
    styles: {
      base: {
        input: {
          fontFamily: 'font-sans',
          color: 'text-phish-fg-1',
          borderRadius: '!rounded-phish',
        },
      },
    },
  },

  card: {
    defaultProps: { variant: 'filled' as const, shadow: false },
    styles: {
      base: {
        initial: {
          backgroundColor: 'bg-phish-bg-2',
          borderWidth: 'border',
          borderColor: 'border-phish-border',
          borderRadius: 'rounded-phish-lg',
          boxShadow: 'shadow-none',
        },
      },
    },
  },

  chip: {
    defaultProps: { variant: 'outlined' as const },
    styles: {
      base: {
        chip: {
          fontFamily: 'font-mono',
          borderRadius: '!rounded-phish',
          textTransform: 'uppercase',
        },
      },
    },
  },
};

export default phishTheme;
